"use client"

import Link from "next/link"
import { Inbox, Users, Share2, Settings, ArrowRight } from "lucide-react"
import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"

const sections = [
  {
    title: "Deposits",
    description: "Review and manage USDC deposit approvals and rejections",
    href: "/deposits",
    icon: Inbox,
  },
  {
    title: "Users",
    description: "View registered users, profiles, and application statuses",
    href: "/users",
    icon: Users,
  },
  {
    title: "Referrals",
    description: "Track referral codes, activity, and reward distribution",
    href: "/referrals",
    icon: Share2,
  },
  {
    title: "Settings",
    description: "Configure contracts, admin roles, and system parameters",
    href: "/settings",
    icon: Settings,
  },
]

export default function OverviewPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Overview</h1>
      <div className="grid gap-4 sm:grid-cols-2">
        {sections.map(({ title, description, href, icon: Icon }) => (
          <Link key={href} href={href}>
            <Card className="group h-full transition-colors hover:border-primary/30 hover:bg-accent/50">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="flex size-9 items-center justify-center rounded-md bg-primary/10 text-primary">
                      <Icon className="size-4" />
                    </div>
                    <CardTitle className="text-base">{title}</CardTitle>
                  </div>
                  <ArrowRight className="size-4 text-muted-foreground opacity-0 transition-opacity group-hover:opacity-100" />
                </div>
                <CardDescription className="mt-2">
                  {description}
                </CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
